export default "./dist/stdassets/images/icons/application-browser.png";